"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import 'react';
import { Avatar } from './components/Avatar/Avatar.mjs';
import { Text } from '../Text/Text.mjs';
import styles from './FileCard.module.scss.mjs';
import clsx from 'clsx';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import { FileSizeText } from './components/FileSizeText/FileSizeText.mjs';
import { Link } from '../Link/Link.mjs';
import { Wrap } from '../Wrap/Wrap.mjs';
import { DeleteButton } from './components/DeleteButton/DeleteButton.mjs';
import '../../lib/propsContext/propsContext.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { OptionsButton } from '../List/components/Items/components/Item/components/OptionsButton/OptionsButton.mjs';

const FileCard = flowComponent("FileCard", (props) => {
  const {
    ref,
    onDelete,
    type,
    sizeInBytes,
    name,
    className,
    elementType = "div",
    onPress,
    href,
    target,
    download,
    imageSrc,
    children
  } = props;
  const rootClassName = clsx(styles.fileCard, className);
  const propsContext = {
    ContextMenu: {
      wrapWith: /* @__PURE__ */ jsx(OptionsButton, {}),
      placement: "bottom right"
    }
  };
  const Element = elementType;
  return /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, mergeInParentContext: true, children: /* @__PURE__ */ jsxs(Element, { ref, className: rootClassName, children: [
    /* @__PURE__ */ jsx(Wrap, { if: href || onPress, children: /* @__PURE__ */ jsxs(
      Link,
      {
        className: styles.link,
        unstyled: true,
        href,
        onPress,
        target,
        download,
        children: [
          /* @__PURE__ */ jsx(Avatar, { type, imageSrc }),
          /* @__PURE__ */ jsxs("span", { className: styles.text, children: [
            /* @__PURE__ */ jsx(Text, { className: styles.title, children: /* @__PURE__ */ jsx("b", { children: name }) }),
            sizeInBytes && /* @__PURE__ */ jsx(FileSizeText, { sizeInBytes })
          ] })
        ]
      }
    ) }),
    onDelete && children === void 0 && /* @__PURE__ */ jsx(DeleteButton, { onDelete }),
    children
  ] }) });
});

export { FileCard, FileCard as default };
//# sourceMappingURL=FileCard.mjs.map
